import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Components
import CircleImage from '../../../components/CircleImage'

class MarkImage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      imageSubmitted: false
    }

    this.submitImage = this.submitImage.bind(this)
    this.onCircleImageClose = this.onCircleImageClose.bind(this)
    this.circleDrag = this.circleDrag.bind(this)
  }

  submitImage (image) {
    let images = [...this.props.images]
    images[image.index] = image.image

    this.setState({ imageSubmitted: true }, () => {
      this.props.updateState({ images: images })
      this.props.updateModal({
        tabView: 'draft'
      })
    })
  }

  onCircleImageClose (image) {
    if (!this.state.imageSubmitted) {
      let images = [...this.props.images]
      images[image.index] = image.image

      this.props.updateState({ images: images })
      this.props.updateModal({
        tabView: 'draft'
      })
    } else {
      this.setState({
        imageSubmitted: false
      })
    }
  }

  circleDrag (active) {
    this.props.updateModal({ overflowHidden: false })
  }

  render () {
    return (
      <CircleImage
        submitImage={this.submitImage}
        image={this.props.currentImg}
        onDrag={this.circleDrag}
        onCircleImageClose={this.onCircleImageClose} />
    )
  }
}

MarkImage.propTypes = {
  currentImg: PropTypes.object.isRequired,
  images: PropTypes.array.isRequired,
  updateState: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired
}

export default MarkImage



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/MarkImage/index.js